export enum MultiBuyerRole {
  MultiBuyer = 'multiBuyer',
  MasterMultiBuyer = 'masterMultiBuyer',
  MbManager = 'mbManager',
  None = 'none',
}

export enum EntityType {
  Owned = 'owned',
  ServicePartner = 'servicePartner',
}

export enum MultiBuyerCompany {
  YouGov = 'yougov',
  Quantilope = 'quantilope',
  None = 'none',
}

export const MULTI_BUYER_ROLES_NUM_MASK: Record<MultiBuyerRole, number> = {
  [MultiBuyerRole.MultiBuyer]: 6,
  [MultiBuyerRole.MbManager]: 6,
  [MultiBuyerRole.MasterMultiBuyer]: 7,
  [MultiBuyerRole.None]: 0,
};

export function isMultiBuyerRole(
  value: MultiBuyerRole | undefined | null
): boolean {
  return value != null && value !== MultiBuyerRole.None;
}

export interface AccessibleEntity {
  id: number;
  type: EntityType;
}

export interface MultiBuyerCapabilities {
  canManageBuyerSettings: boolean;
  canCreateTemplate: boolean;
  canSeeMarginAndBank: boolean;
  hasAccessToTemplate: boolean;
  canSeeCustomTemplates: boolean;
  canManageSupplierSettings: boolean;
  canSeeSupplierBlends: boolean;
  canSeeOperatorProjectManager: boolean;
  canSeeCrmId: boolean;
  canAccessMasterTemplate: boolean;
}

export interface AccessControlConfig {
  clientId: number;
  userRole: MultiBuyerRole;
  clientName: MultiBuyerCompany;
  buyerAcssLvls: number;
  multiBuyerCmps: Array<number>;
  capabilities: MultiBuyerCapabilities;
  accessibleEntities: AccessibleEntity[];
}

export interface IMultiBuyerPermissions {
  canManageBuyerSettings(): boolean;
  canCreateTemplate(): boolean;
  canSeeMarginAndBank(): boolean;
  hasAccessToTemplate(): boolean;
  canSeeCustomTemplates(): boolean;
  canSeeOperatorProjectManager(): boolean;
  canSeeCrmId(): boolean;
  canManageSupplierSettings(): boolean;
  canSeeSupplierBlends(): boolean;
  canAccessMasterTemplate(): boolean;
}
